import { HttpClient, HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(private http: HttpClient) {}

  getAll(url) {
    return this.http.get<any>(`${environment.apiUrl}${url}`).pipe(
      catchError((res: any) => {
        if (res.status === HttpStatusCode.InternalServerError) {
          return throwError(() => 'Algo esta fallando en el servidor, por favor contacte a soporte')
        }
        if (res.status === HttpStatusCode.BadRequest) {
          return throwError(() => res.error)
        }
        if (res.status === HttpStatusCode.Unauthorized) {
          return throwError(() => 'El acceso a esta solicitud no estas permitido')
        }
        return throwError(() => 'Ups algo salio mal, por favor contacte a soporte')
      }),
      map((response: any) => {
        if (response.hasOwnProperty('payload')) {
          return response.payload
        }

        return response
      })
    )
  }

  create(url, data) {
    return this.http.post<any>(`${environment.apiUrl}${url}`, data).pipe(
      catchError((res: HttpErrorResponse) => {
        if (res.status === HttpStatusCode.InternalServerError) {
          return throwError(() => 'Algo esta fallando en el servidor, por favor contacte a soporte')
        }
        if (res.status === HttpStatusCode.BadRequest) {
          return throwError(() => res.error)
        }
        if (res.status === HttpStatusCode.Unauthorized) {
          return throwError(() => 'El acceso a esta solicitud no estas permitido')
        }
        return throwError(() => 'Ups algo salio mal, por favor contacte a soporte')
      }),
      map((response: any) => {
        if (response.hasOwnProperty('payload')) {
          return response.payload
        }
        return response
      })
    )
  }

  update(url, data) {
    return this.http.put<any>(`${environment.apiUrl}${url}`, data).pipe(
      catchError((res: HttpErrorResponse) => {
        if (res.status === HttpStatusCode.InternalServerError) {
          return throwError(() => 'Algo esta fallando en el servidor, por favor contacte a soporte')
        }
        if (res.status === HttpStatusCode.BadRequest) {
          return throwError(() => res.error)
        }
        if (res.status === HttpStatusCode.Unauthorized) {
          return throwError(() => 'El acceso a esta solicitud no estas permitido')
        }
        return throwError(() => 'Ups algo salio mal, por favor contacte a soporte')
      }),
      map((response: any) => {
        if (response.hasOwnProperty('payload')) {
          return response.payload
        }
        return response
      })
    )
  }
}
